exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.errorMessages[data-v-1ae3b09e] {\n  margin-bottom: 1em;\n}\n", ""]);

// exports
